import ProsecutionApi from "../../apis/Prosecution";

export default {
  namespaced: true,
  state: {
    prosecutions: [],
    sale: undefined,
    paginated:{}
  },
  mutations: {
    set_prosecutions(state, data) {
      state.prosecutions = data;
    },
    set_sale(state, data) {
      state.sale = data;
    },
    set_paginated (state, data) {
      state.paginated =  data
  }
  },
  actions: {
    emptyServices({ commit }) {
      commit("set_prosecutions", []);
    },
    newProsecutions({ commit, dispatch }, value) {
      commit("set_prosecutions", value);
    },
    resetSale({ commit }) {
      commit("set_sale", null);
    },
    async getProsecution({ commit, dispatch }, filters) {
      return await ProsecutionApi.get_allPaginated(filters)
        .then((response) => {
          commit('set_paginated', {
            ...response.data
        })
          commit("set_prosecutions", response.data.data);
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al listar servicios, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async getSaleByOrden({ commit, dispatch }, value) {
      return await ProsecutionApi.getSaleByOrden(value)
        .then((response) => {
          commit("set_sale", response.data);
          // dispatch(
          //   "notifications/store_notification",
          //   {
          //     type: "success",
          //     message: "El registro se realizó de forma correcta.",
          //   },
          //   { root: true }
          // );
          // dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async store({ dispatch }, analisis) {
      return await ProsecutionApi.store(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "El registro se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al registrar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },

    async update({ dispatch }, analisis) {
      return await ProsecutionApi.update(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La actualización se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          let message = "Ocurrió un error al actualizar, vuelva a intentarlo.";
          if (error.response.data && error.response.data.custom_error) {
            message = error.response.data.custom_error;
          }
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message: message,
            },
            { root: true }
          );
        });
    },
    async delete({ dispatch }, analisis) {
      return await ProsecutionApi.delete(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La eliminación se realizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar eliminar, vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
    async change_status({ dispatch }, analisis) {
      let action = analisis.active ? "inactivación" : "activación";
      return await ProsecutionApi.change_status(analisis)
        .then((response) => {
          dispatch(
            "notifications/store_notification",
            {
              type: "success",
              message: "La " + action + " se relizó de forma correcta.",
            },
            { root: true }
          );
          dispatch("getProsecution");
        })
        .catch((error) => {
          if (error.response?.status === 401) return null
          dispatch(
            "notifications/store_notification",
            {
              type: "error",
              message:
                "Ocurrió un error al intentar realizar la " +
                action +
                ", vuelva a intentarlo.",
            },
            { root: true }
          );
        });
    },
  },
};
